import React, { Component } from "react";
import {
  StyleSheet,
  View,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import User from "./components/User";
import { translate } from "../locales/translate";
import ArTheme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import { Toast } from "native-base";
import ToastAlert from "../nativeBase-ui/ToastAlert";

class EditRibbonUserAccessLevelScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: "",
      isLoading: true,
      isLoadingError: false,
      serverUrl: "",
      users: [],
      areaList: [],
      selectedArea: null,
      searchUsername: null,
      isUserValid: null,
      reservationUser: null,
      units: [],
      owner: "",
      hasUser: true,
      isLoadingUserList: true,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.EditRibbonUserAccessLevel"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    var _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl + "/";
    }
    this.setState({ accessToken, serverUrl: _serverUrl }, () => {
      this.getUser().then(() => {
        this.unitOfUser();
        this.setState({ isLoading: false });
      });
    });
  }
  // === show toast => toast native-base ===
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };
  getUser() {
    return new Promise((resolve, reject) => {
      let { serverUrl, accessToken } = this.state;

      var url = `${serverUrl}/Services/GetRibbonUser/`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
            this.setState({ isUserValid: "No" }, () => {
              resolve();
            });
          } else {
            this.setState({ reservationUser: resj, isUserValid: "Yes" });
            resolve();
          }
        })
        .catch((err) => {
          {
            console.log(err, "get user have error ");
            reject(err);
          }
        });
    });
  }

  postAddOrUpdateRibbonUserInUnit(o, userUnitCredit, increaseUnitCredit) {
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`unitCode=${o.numUnitRef}`);
    args.push(`UseUnitCredit=${userUnitCredit}`);
    args.push(`IncreaseUnitCredit=${increaseUnitCredit}`);
    args.push(`userId=${o.numRibbonUserRef}`);
    var url = `${serverUrl}Services/AddOrUpdateRibbonUserInUnit/?${args.join(
      "&"
    )}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("reservationUserAccess.cancelNoAccess"));
        } else if (resj.errorCode != null) {
          this.showToast(translate("reservationUserAccess.errorChange"));
        } else {
          this.setState({ users: [], isLoadingUserList: true });
          this.unitOfUser();
          this.showToast(
            translate("reservationUserAccess.successChange"),
            "success"
          );
        }
      });
  }

  getReservationUserInUnit(unitId) {
    var { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRibbonUserInUnit/?UnitCode=${unitId}&allUser=${true}`;
    if (unitId == -1) {
      url = `${serverUrl}Services/GetRibbonUserInUnit/?UnitCode=${unitId}&allUser=${false}`;
    }
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errorCode) {
          this.showModel(reservationUserAccess.ribbonErrorMessage);
        } else {
          var ribbonUsers = this.state.users;

          if (resj.length != 0) {
            for (var i in resj) {
              ribbonUsers.push(resj[i]);
            }

            this.setState({ users: ribbonUsers });
          }
        }
      });
  }

  unitOfUser() {
    var areaList = [];
    let areas = this.props.areaReducer.areas;
    for (var i in areas) {
      if ((areas[i].accessLevel = "Admin" && areas[i].areaType == "UNIT")) {
        this.getReservationUserInUnit(areas[i].areaId);
        areaList.push({
          label: areas[i].areaName,
          value: areas[i].areaId,
        });
      }
    }
    if (Platform.OS == "web") {
      areaList.unshift({
        label: translate("reservationUserAccess.areas"),
        value: null,
      });
    }
    this.setState({ areaList: areaList });
  }
  render() {
    var userList = [];
    userList = this.state.users.filter((o) => {
      if (
        (this.state.selectedArea == null ||
          o.numUnitRef == this.state.selectedArea) &&
        (this.state.searchUsername == null ||
          (this.state.searchUsername != null &&
            o.strUserFullName.indexOf(this.state.searchUsername) >= 0))
      )
        return o;
    });
    userList.sort((a, b) => (a.numUnitRef > b.numUnitRef ? 1 : -1));
    // first wait
    if (this.state.isLoading)
      return <Loading message={translate("app.pleaseWaite")} />;
    // if occur error
    else if (this.state.isLoadingError) {
      return (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <Text
            style={{
              color: ArTheme.COLORS.ERROR,
              textAlign: "center",
            }}
          >
            {translate("app.loadingError")}
          </Text>
        </View>
      );
    }
    // if user don't owner
    // if (this.state.owner == "No") {
    //   return (
    //     <View
    //       style={{
    //         alignItems: "center",
    //         flexDirection: "row",
    //         justifyContent: "center",
    //         flex: 1,
    //       }}
    //     >
    //       <Text style={{ fontSize: 20, color: "#666666" }}>
    //         {translate("api.unitOwnerManageUnitCredit")}
    //       </Text>
    //     </View>
    //   );
    // }
    // if (this.state.owner=="Yes" &&  !this.state.hasUser ) {
    //   return (
    //     <View
    //       style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
    //     >
    //       <Text>{translate("api.haveNotUserInUnit")}</Text>
    //     </View>
    //   );
    // }
    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        <View style={{ paddingStart: 5, paddingEnd: 5, paddingVertical: 5 }}>
          <InputSearch
            placeholder={translate("reservationUserAccess.searchUsername")}
            value={this.state.searchUsername || ""}
            onChangeText={(txt) => {
              this.setState({ searchUsername: txt });
            }}
          />
          {this.state.areaList.length > 0 && (
            <View style={{ flex: 1, marginTop: 8 }}>
              <Select
                placeholder={translate("reservationUserAccess.areas")}
                data={this.state.areaList}
                value={
                  Platform.OS == "web"
                    ? this.state.selectedArea
                    : translate("reservationUserAccess.areas") ||
                      this.state.selectedArea
                }
                onChangeText={(value, index, data) => {
                  this.setState({ selectedArea: value });
                }}
              />
            </View>
          )}
        </View>
        {userList.length != 0 && (
          <View
            style={{
              borderBottomColor: ArTheme.COLORS.BORDER_COLOR,
              borderBottomWidth: 2,
              flexDirection: "row",
              justifyContent: "space-between",
              minHeight: 20,
              paddingEnd: 12,
              borderTopColor: ArTheme.COLORS.BORDER_COLOR,
              borderTopWidth: 1,
            }}
          >
            <View style={{ minWidth: 150 }}>
              <Text>{translate("reservationUserAccess.user")}</Text>
            </View>
            <View>
              <Text>{translate("reservationUserAccess.unit")}</Text>
            </View>

            <Text>{translate("reservationUserAccess.useCredit")}</Text>
            <View>
              <Text>{translate("reservationUserAccess.increaseCredit")}</Text>
            </View>
            <View style={{ width: 25 }} />
          </View>
        )}
        <View style={{ flex: 1 }}>
          <ScrollView style={{ flex: 1, marginBottom: 40 }}>
            {userList.map((o) => {
              return (
                <User
                  user={o}
                  key={o.numRibbonUserRef + o.numUnitRef}
                  onSaveEdit={(o, userUnitCredit, increaseUnitCredit) => {
                    this.postAddOrUpdateRibbonUserInUnit(
                      o,
                      userUnitCredit,
                      increaseUnitCredit
                    );
                  }}
                />
              );
            })}
          </ScrollView>
        </View>
      </KeyboardAvoidingView>
    );
  }
}

const style = StyleSheet.create({});

const mapStateToProps = (state) => {
  return {
    reducer: state.ApiReducer,
    areaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

export default connect(mapStateToProps)(EditRibbonUserAccessLevelScreen);
